import { useLanguagePreference } from '../../hooks/useLanguagePreferenceContext/useLanguagePreference';
import { CodeDataEditor, CodeLanguageSelect } from '../Code/Code';
import { ToolEditor } from './ToolEditor';

export interface ToolCallListItem {
  name: string;
  id?: string;
  args: string | Record<string, unknown>;
}

export interface ToolCallsListProps {
  items: Array<ToolCallListItem>;
  editable?: boolean;
  onChangeName?: (index: number, name: string) => void;
  onChangeId?: (index: number, id: string) => void;
  onChangeArgs?: (index: number, value: unknown) => void;
  onDelete?: (index: number) => void;
  testIdPrefix?: string;
}

export function ToolCallsList(props: ToolCallsListProps) {
  const [userLang, setUserLang] = useLanguagePreference();

  return (
    <div className="flex flex-col divide-y divide-secondary">
      {props.items.map((item, index) => (
        <div key={index} className="flex flex-col divide-y divide-secondary">
          {props.editable ? (
            <ToolEditor
              name={item.name}
              onChangeName={(name) => props.onChangeName?.(index, name)}
              id={item.id ?? ''}
              onChangeId={(id) => props.onChangeId?.(index, id)}
              onDelete={() => props.onDelete?.(index)}
            />
          ) : (
            <span
              className="cursor-default px-4 py-3 font-mono"
              data-testid={`tool_call_function_name_${item.name}`}
            >
              {item.name}{' '}
              {item.id && (
                <span className="rounded-md border border-tertiary px-1 py-1 text-sm text-tertiary">
                  {item.id}
                </span>
              )}
            </span>
          )}
          <CodeDataEditor
            readOnly={!props.editable}
            language={userLang}
            value={item.args}
            onChange={
              props.editable && props.onChangeArgs
                ? (value) => props.onChangeArgs?.(index, value)
                : undefined
            }
          />
        </div>
      ))}
      <div className="flex items-center justify-start">
        <CodeLanguageSelect value={userLang} onChange={setUserLang} />
      </div>
    </div>
  );
}
